const RoutesList = {
    login: '/login',
    signup: '/signup',
    onevsone: '/game/:gameid',
    playervscomputer: "/playervscomputer",
    playgame: "/playgame",
}

export default RoutesList;
